import React from "react";
import { Check, Loader2, Circle, X } from "lucide-react";

/**
 * Step icon for sync progress. One function per file.
 */
export function getStepIcon(status: string): React.ReactNode {
  switch (status) {
    case "completed":
      return <Check className="w-4 h-4 text-white" />;
    case "in_progress":
      return <Loader2 className="w-4 h-4 text-white animate-spin" />;
    case "failed":
      return <X className="w-4 h-4 text-white" />;
    default:
      return <Circle className="w-4 h-4 text-slate-400" />;
  }
}
